module.exports = __webpack_public_path__ + "static/media/liquidity-add.07b3cf2a.svg";